import React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import supportTopics from "@/data/support-topics"

const SupportTopicMobileNav = ({ className = "" }) => {
  const { t } = useTranslation()

  return (
    <div className={`support-topic-mobile-nav ${className}`}>
      <input
        className="support-topic-mobile-nav__toggle-input"
        type="checkbox"
        id="support-portal-support-topic-mobile-nav"
      />
      <div className="support-topic-mobile-nav__menu-wrapper">
        <div className="support-topic-mobile-nav__browse-topic-wrapper">
          <label
            className="support-topic-mobile-nav__toggle"
            htmlFor="support-portal-support-topic-mobile-nav"
          >
            {t("support.browse-support-topics")}
            <svg
              className="support-topic-mobile-nav__icon"
              width="15"
              height="22"
              viewBox="0 0 9 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.13057 0.217921L4.49872 3.49251L7.91101 0.174993V0.175425C8.02672 0.0666752 8.184 0 8.35714 0C8.712 0 9 0.28 9 0.625C9 0.79375 8.93143 0.946256 8.81958 1.05876L8.81999 1.05916L4.96285 4.80916L4.96243 4.80876C4.84586 4.92667 4.68171 5 4.5 5C4.49957 5 4.49915 5 4.49872 5C4.49829 5 4.49743 5 4.497 5C4.31529 5 4.15157 4.92667 4.03457 4.80876V4.80916L0.176998 1.05916L0.178711 1.05751C0.0681395 0.94501 0 0.792917 0 0.625C0 0.28 0.288 0 0.642857 0C0.837857 0 1.01229 0.0845876 1.13057 0.217921Z"
                fill="#111111"
              />
            </svg>
          </label>
        </div>
        <ul className="support-topic-mobile-nav__menu">
          {supportTopics.map(topic => (
            <li key={topic.id} className="support-topic-mobile-nav__list-item">
              <Link
                to={`/support/${topic.id}`}
                className="support-topic-mobile-nav__item"
              >
                {t(`support.topic.${topic.id}.name`)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default SupportTopicMobileNav
